/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

var props = {
  allowInputOverMax: Boolean,
  autofocus: Boolean,
  autosize: {
    type: [Boolean, Object],
    "default": false
  },
  disabled: {
    type: Boolean,
    "default": void 0
  },
  maxcharacter: {
    type: Number
  },
  maxlength: {
    type: [String, Number]
  },
  name: {
    type: String,
    "default": ""
  },
  placeholder: {
    type: String,
    "default": void 0
  },
  readonly: {
    type: Boolean,
    "default": void 0
  },
  status: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "success", "warning", "error"].includes(val);
    }
  },
  tips: {
    type: [String, Function]
  },
  value: {
    type: [String, Number],
    "default": void 0
  },
  modelValue: {
    type: [String, Number],
    "default": void 0
  },
  defaultValue: {
    type: [String, Number]
  },
  onBlur: Function,
  onChange: Function,
  onFocus: Function,
  onKeydown: Function,
  onKeypress: Function,
  onKeyup: Function,
  onValidate: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
